export var GAActions = {
  SEARCH_PAGE: 'Search Result Page',
  ADD_TO_WATCHLIST: 'Add to Watchlist',
  CREATE_PROPERTY_ALERT: 'Create Property Alert',
  MAP_VIEW: 'Map View',
  VIEW_SOLD: 'View Sold',
  LOCATION_ENTRY: 'Location Entry',
  FEATURE_PROPERTY: 'Feature Property',
  INLINE_AD_CLICK: 'Inline Ad Click',
  MAP_INTERACTION: 'Map Interaction',
  TOGGLE_MAP_VIEW: 'SearchResults_MapViewClick',
  TOGGLE_LIST_VIEW: 'SearchResults_ListViewClick',
  ALERT_ACTION: 'Property Alerts',
  SEARCH_RESULTS: 'Search Results Page'
};
export var GALabels = {
  SCHOOL_SEARCH: 'School Search',
  PROJECT_SEARCH: 'Project Search',
  ADDRESS_SEARCH: 'Address Search',
  CREATE_PROPERTY_ALERT: 'Create Property Alert',
  MAP_VIEW: 'View Map',
  VIEW_SOLD: 'View Sold',
  LOCATION_ENTRY: 'Location Entry',
  FEATURE_PROPERTY: 'Feature Property Click - Position ',
  MAP_ZOOM: 'MapZoom',
  MAP_MOVE: 'MapMove',
  PIN_CLICK: 'PinClick',
  ADVANCED_MAPPING_CLICK: 'AdvancedMapClick',
  WATCHLIST_MAP_CARD: 'MapListingCardWatchlist',
  ALERT_CLICK: 'Search Result - Enter property alert mode',
  CREATE_ALERT: 'Search Result - Create property alert - CTA',
  MANAGE_ALERT: 'Search Result - Manage property alert ',
  EDIT_ALERT: 'Search Result - Edit property alert ',
  REMOVE_ALERT: 'Search Result - Remove property alert '
};
export var MixpanelLabels = {
  SOLD_FLOATING_CTA: 'Search Result - Floating CTA',
  SOLD_AGENCY_CARDS: 'Search Result - Sold - Agency Cards'
};
export var PageSection = {
  'search-results': 'Search Results',
  'similar-properties': 'Similar Properties'
};